import {Component, Input, OnInit, TemplateRef} from '@angular/core';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: []
})
export class DropdownComponent implements OnInit {

  @Input() content: TemplateRef<any>;

  constructor() { }

  ngOnInit() {
  }

}
